import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import { a } from './_csAbt';
import * as ls from './_csLcl';
import * as cmFTH from './_cmFTH';

import * as LblC from './_cccLblC';
import * as IptC from './_ccbIptC';

let $pcrs = [] as ht.ls;

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    elm: ht.s,
//    _fst: ht.n,
    cdn?: ht.s,
  }
}) => {

  const _udtThis = ls.udtThis();

  React.useEffect(() => {
    const _tgt = pz.cz.elm + 's';
    let _cdn = cmFTH.vdd(false);
    _cdn += (pz.cz.cdn) ? ` AND (${pz.cz.cdn})` :` AND _fst = ${pz.sPz.crt[`${pz.cz.elm}_fst`]}`;
    //hf.l(`_HtyC 28: ${_cdn}`)
    cmFTH.loadLsAsync({
      tgt: _tgt,
      cdn: _cdn, // 全体共通
//      fld: `_vsn as key, _dtm as pfx, *`,
//      fld: `_vsn as key, _dtm || (SELECT A._pfx FROM _10rz AS A WHERE COALESCE(A._dlt,-1) <> 1 AND A._key = ${_tgt}_who) as pfx, *`,
      fld: `_vsn as key, _dtm || ' ' || COALESCE((SELECT CASE WHEN A._10rt1100i = 10 THEN 'WEB' WHEN A._10rt1100i = 20 THEN '窓口' ELSE '他' END FROM _10rs AS A WHERE COALESCE(A._dlt,-1) <> 1 AND A._key = ${_tgt}._who), '他') as pfx, *`,
      tailz: {
        odr: '_dtm desc'
      }
    })
    .then((_ls: ht.ls) => {
      $pcrs = _ls;
      _udtThis();
    });
  }, [
    pz.sPz.crt.vsn
  ])

  if (pz.sPz.crt.phs != 'dpy') return null;

  return (
    cr.c(LblC.N, {
      key: -10,
      abtType: 'ftnCmnz',
      boxStlz: a('dw/23'),
      lblCz: {
        boxStlz: a('dw/8'),
        textz: {
          pfx: '履歴',
        }
      },
      cttCz: {
        oClds: [
          cr.c(IptC.S, {
            key: -10,
            abtType: 'ftnCmnz',
            cz: {
              bEdit: true,
              iptType: 'pcr',
              ls: $pcrs,
              vle: pz.sPz.crt.vsn,
              onChg: (_dz: ht.dz) => {
                pz.sPz.set({
                  vsn: _dz.key
                })
              }
            },
          })
        ]
      },
    })
  )
};
